export default __webpack_public_path__ + "static/media/Copy_of_DSC_0041.2093e3c7.jpg";